import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useNavigation } from "@/contexts/notification/NavigationContext";
const PageTracker = () => {
  const location = useLocation();
  const { trackPageVisit } = useNavigation();

  useEffect(() => {
    trackPageVisit(location.pathname);
  }, [location.pathname, trackPageVisit]);

  return null; // This is a utility component that doesn't render anything
};

export default PageTracker;
